export default {
  hero: {
    title: '资源中心',
    subtitle: '探索合规解读、运维知识、交付模板与专题活动，帮助企业更高效地推进亚太区域 IT 服务与数字化建设。',
    imageAlt: '资源中心背景图',
    searchPlaceholder: '搜索洞察、文档或活动...'
  },
  tabs: {
    all: '全部资源',
    insights: '行业洞察',
    downloads: '资料下载',
    knowledge: '技术知识库',
    events: '活动资讯'
  },
  insights: {
    title: '行业洞察',
    subtitle: '围绕亚太区域的数据保护、托管交付与云平台韧性，整理适合企业官网、客服、CRM 与运维场景的重点观察。',
    viewAll: '查看全部洞察',
    readMore: '阅读更多',
    items: [
      {
        id: 1,
        title: '2026 新加坡 PDPA 落地重点：从治理责任到 ICT 控制闭环',
        description: '结合 PDPC 公开资料，梳理 DPO 职责、官网表单采集、供应商处理边界与数据泄露通知演练等四类高频落地点。',
        image: '/images/resourceCenter/insight-report.jpg',
        badge: '合规观察',
        badgeColor: 'bg-blue-600',
        date: '2026年4月10日',
        readTime: '8分钟阅读',
        author: '张明宇',
        authorAvatar: '/images/resourceCenter/author-zhang.png'
      },
      {
        id: 2,
        title: '韩国 PIPA 2026 实务观察：跨境、委托处理与高风险系统控制',
        description: '针对跨国企业在韩国开展官网、客户支持和区域协作时最常见的委托处理、跨境协作与留痕要求进行结构化梳理。',
        image: '/images/resourceCenter/insight-singapore-pdpa.jpg',
        badge: '政策解读',
        badgeColor: 'bg-green-600',
        date: '2026年4月9日',
        readTime: '7分钟阅读',
        author: '林美玲',
        authorAvatar: '/images/resourceCenter/author-lin.png'
      },
      {
        id: 3,
        title: '云平台韧性基线：多区域容灾、备份演练与恢复顺序的关键取舍',
        description: '从官网、客服、通知链路与 CRM 的连续性要求出发，整理多区域容灾设计、切换顺序和 Runbook 固化的实务建议。',
        image: '/images/resourceCenter/insight-korea-pipa.jpg',
        badge: '架构策略',
        badgeColor: 'bg-red-600',
        date: '2026年4月12日',
        readTime: '9分钟阅读',
        author: '金明洙',
        authorAvatar: '/images/resourceCenter/author-kim.png'
      }
    ]
  },
  downloads: {
    title: '资料下载',
    subtitle: '下载整理为 PDF 的检查清单与模板文档，便于内部传阅、客户汇报和项目交接时直接复用。',
    viewAll: '查看全部资料',
    action: '下载',
    items: [
      {
        id: 1,
        title: '《亚太数据保护准备度清单》',
        description: '覆盖官网、客户支持、CRM、营销自动化与第三方 SaaS 的最小治理与合规检查项，适合季度盘点与客户汇报。',
        badge: '检查清单',
        badgeClass: 'text-blue-600 bg-blue-50',
        iconBg: 'bg-blue-100 text-blue-600',
        iconClass: 'fas fa-list-check text-blue-600',
        date: '2026年4月更新',
        fileInfo: 'PDF 检查清单'
      },
      {
        id: 2,
        title: '《多区域容灾 Runbook 模板》',
        description: '包含切换触发条件、恢复顺序、外部沟通模板与演练复盘项，适用于官网、客服与业务支撑系统的连续性设计。',
        badge: '运维模板',
        badgeClass: 'text-green-600 bg-green-50',
        iconBg: 'bg-green-100 text-green-600',
        iconClass: 'fas fa-file-lines text-green-600',
        date: '2026年4月更新',
        fileInfo: 'PDF Runbook 模板'
      },
      {
        id: 3,
        title: '《托管服务交接与上线检查清单》',
        description: '用于新项目上线、供应商切换与服务移交前的资料、权限、沟通与验收核查，适合交付经理与运维团队联合使用。',
        badge: '交付模板',
        badgeClass: 'text-purple-600 bg-purple-50',
        iconBg: 'bg-purple-100 text-purple-600',
        iconClass: 'fas fa-clipboard-check text-purple-600',
        date: '2026年4月更新',
        fileInfo: 'PDF 交接清单'
      }
    ]
  },
  knowledge: {
    title: '技术知识库',
    subtitle: '围绕集群运维、故障分诊、数据保护和交付协同，提供更适合托管服务场景的短文档与操作建议。',
    viewAll: '查看全部文档',
    readDoc: '阅读文档',
    categories: {
      all: '所有分类',
      operation: '运维技巧',
      troubleshooting: '故障排查',
      compliance: '合规操作',
      security: '安全防护'
    },
    hotTitle: '热门技术文档',
    hotSubtitle: '围绕生产环境运行、恢复和审计要求整理的实用资料。',
    operationTitle: '运维技巧',
    troubleshootingTitle: '故障排查',
    hotDocuments: [
      {
        id: 1,
        title: 'Kubernetes 控制面与 etcd 备份恢复运行手册',
        description: '聚焦 kubeadm 集群、etcd 快照、控制面恢复验证与业务入口联调，适合生产环境平台团队参考。',
        category: '运维技巧',
        categoryClass: 'bg-blue-50 text-blue-600',
        iconBg: 'bg-blue-100 text-blue-600',
        iconClass: 'fas fa-server text-blue-600',
        views: '1.9k 阅读',
        date: '2026年4月',
        comments: '18 讨论'
      },
      {
        id: 2,
        title: '分布式故障分诊与沟通矩阵：先定级、再止血、再归因',
        description: '帮助团队在官网、客服、API 和中间件故障时快速统一分诊口径、角色分工和对外沟通节奏。',
        category: '故障排查',
        categoryClass: 'bg-red-50 text-red-600',
        iconBg: 'bg-red-100 text-red-600',
        iconClass: 'fas fa-bug text-red-600',
        views: '1.6k 阅读',
        date: '2026年4月',
        comments: '12 讨论'
      },
      {
        id: 3,
        title: '数据中心与托管服务安全检查清单：账号、日志、变更与第三方访问',
        description: '适合季度审计、供应商复核与客户侧汇报使用，覆盖权限、日志、变更留痕和第三方远程访问控制。',
        category: '合规操作',
        categoryClass: 'bg-green-50 text-green-600',
        iconBg: 'bg-green-100 text-green-600',
        iconClass: 'fas fa-shield-alt text-green-600',
        views: '1.3k 阅读',
        date: '2026年4月',
        comments: '9 讨论'
      }
    ],
    operationTips: [
      'Kubernetes 控制面变更前，先校验备份、证书与恢复依赖是否齐全',
      '把自动化发布、配置变更和回滚脚本纳入同一套值班手册',
      '为数据库、对象存储与消息队列分别设定备份与验证周期',
      '容器化应用的日志保留策略应覆盖排障、审计与对外汇报三类场景'
    ],
    troubleshootingTips: [
      '发生入口异常时，先按客户触点、控制面、数据面与第三方依赖拆解影响范围',
      '统一技术负责人、业务接口人与对外更新时间，避免多头沟通',
      '故障演练不仅要验证恢复，还要验证 DNS、证书、通知链路与工单系统',
      '复盘时记录阻塞点、手工步骤与供应商依赖，推动 Runbook 固化'
    ]
  },
  events: {
    title: '活动资讯',
    subtitle: '围绕数据保护、托管运维、容灾演练与平台治理，整理已完成专题活动的回顾、纪要与实践要点。',
    viewAll: '查看全部活动',
    featured: {
      badge: '闭门研讨会回顾',
      title: '2026 亚太数据韧性与合规闭门研讨会回顾',
      description: '围绕官网、客服、CRM 与托管运维的连续性设计，整理闭门讨论中形成的共识、分歧与后续行动建议。',
      date: '2026年3月12日',
      location: '新加坡 / 线上同步',
      audience: 'IT 管理者、DPO、平台运维团队',
      status: '活动已结束',
      metaNote: '会后纪要与相关资料已归档',
      action: '查看回顾'
    },
    recentTitle: '近期回顾',
    recentSubtitle: '以下均为已完成活动的回顾、摘要与资料整理。',
    recentItems: [
      {
        id: 1,
        day: '26',
        month: '03月',
        dateBg: 'bg-blue-100 text-blue-700',
        badge: '专题回顾',
        badgeClass: 'bg-blue-50 text-blue-700',
        title: '新加坡 PDPA 与数据泄露通知实务回顾',
        icon: 'far fa-clock',
        info: '线上专题 · 纪要已发布',
        action: '查看回顾',
        linkClass: 'text-blue-600 hover:text-blue-700'
      },
      {
        id: 2,
        day: '05',
        month: '03月',
        dateBg: 'bg-green-100 text-green-700',
        badge: '工作坊回顾',
        badgeClass: 'bg-green-50 text-green-700',
        title: 'Kubernetes 控制面与 etcd 备份演练回顾',
        icon: 'fas fa-map-marker-alt',
        info: '上海 · 线下实操纪要',
        action: '查看回顾',
        linkClass: 'text-green-600 hover:text-green-700'
      },
      {
        id: 3,
        day: '20',
        month: '02月',
        dateBg: 'bg-purple-100 text-purple-700',
        badge: '圆桌回顾',
        badgeClass: 'bg-purple-50 text-purple-700',
        title: '区域容灾切换演练设计圆桌回顾',
        icon: 'far fa-clock',
        info: '线上圆桌 · 要点摘要',
        action: '查看回顾',
        linkClass: 'text-purple-600 hover:text-purple-700'
      },
      {
        id: 4,
        day: '16',
        month: '01月',
        dateBg: 'bg-red-100 text-red-700',
        badge: '简报回顾',
        badgeClass: 'bg-red-50 text-red-700',
        title: '托管服务交接与 SLA 沟通简报回顾',
        icon: 'fas fa-map-marker-alt',
        info: '线上简报 · 资料已归档',
        action: '查看回顾',
        linkClass: 'text-red-600 hover:text-red-700'
      }
    ]
  },
  contactCta: {
    badge: '联系我们',
    title: '需要结合您业务场景获取更合适的资料与建议？',
    subtitle: '如果您正在推进官网建设、区域交付、托管运维、容灾演练或客户支持优化，可以直接联系我们。我们会结合您的场景，协助梳理可参考的资料、实施重点与区域支持方式。',
    highlights: [
      '官网与客户支持咨询',
      '区域交付与运维协同',
      '资料获取与方案沟通'
    ],
    note: '支持中国大陆、新加坡、日本、韩国等区域业务沟通。',
    action: '前往联系我们'
  }
}
